module.exports = __webpack_public_path__ + "static/media/SUSHI.328a4bb1.svg";